// extracted by mini-css-extract-plugin
export var textInput = "_lc-0";